var exports = {
  "BN": "VoiceGridLayout.module__gridViewport___amZKUF",
  "Om": "VoiceGridLayout.module__gridViewportCompact___amZKUF",
  "Vg": "VoiceGridLayout.module__grid___amZKUF",
  "ux": "VoiceGridLayout.module__gridItem___amZKUF",
};

module.exports = exports;
